/* @flow */

import type { CombinedReducers } from '../../../../reducers';
import type { Dispatch } from '../../../../types/types';
import type { RequestResponseMethodDefinitionType } from '../../emitter';
import type { Distributor } from '../types/common';

import { type AllSettledPromises, SettledPromiseFulfilled } from '../../../../../helpers/jsHelpers/promise';
import { updateBOState } from '../../../../appConf/actions';
import sendDiscoveryRequestForDistributor from '../discovery';

const sendDiscoveryRequest: (signal?: AbortSignal) => RequestResponseMethodDefinitionType =
  (signal) =>
  (dispatch: Dispatch, getState: () => CombinedReducers): Promise<void> => {
    const {
      appConfiguration: { distributorAppKeys },
    } = getState();

    const promises: Array<Promise<Distributor>> = Array.from(Object.keys(distributorAppKeys)).map((distributorId) => dispatch(sendDiscoveryRequestForDistributor(distributorId, signal)));

    return Promise.allSettled(promises).then((results: AllSettledPromises<Distributor>) => {
      for (const result of results) {
        if (result.status === SettledPromiseFulfilled) {
          const { urls } = result.value;
          if (Object.keys(urls).length > 0) {
            dispatch(updateBOState(true));
            break;
          }
        }
      }
    });
  };

export default sendDiscoveryRequest;
